/**
 * import {resetContentHolders} from 'Utils/UI';
 * import {populateEditView} from 'Default';
 */
// UI 
(function(){
    //Victim Controller
    //Variables 
    var aElementPrefixId ='uVictimProfile',
        aContentHolderId = '#uEnrolleesSecondaryContentHolder',
        editBtn = '#uEditVictimButton',
        AddBtn = '#uAddVictimButton',
        SaveBtn = '#uSaveVictimButton',
        CancelBtn = '#uCancelVictimButton',
        sama_property= 'enable_sama',
        aTempVictim = null;

    var VictimController = {
        elementPrefixId:aElementPrefixId,
        aContainerId:aElementPrefixId+'Panel',
        aLoadingId:aElementPrefixId+'LoadingBar',
        aButtonBarId:aElementPrefixId+'ButtonBar',
        IsEditMode:false,
        PairChanged:false,
        DisableSAMA:false,
        showLoading: function(){
            $('#'+this.aLoadingId).show();
            $('#'+this.aContainerId).hide();
            $('#'+this.aButtonBarId+' .ButtonCommandBarBox').hide();
        },
        hideLoading: function(){
            $('#'+this.aLoadingId).hide();
            $('#'+this.aContainerId).show();
            $('#'+this.aButtonBarId+' .ButtonCommandBarBox').show();
        }
    };
     /**
     * This Function contains all the Form Object.
     */
    VictimController.Form = function VictimProfileForm(){
        var obj ={}
        obj.detail = new FieldsFormController('uEnrolleeProfile','',[
        {name:'FirstName',type:'string'},
        {name:'LastName',type:'string'},
        {name:'FullName',type:'string'},
        {name:'AgentId',type:'number'},
        {name:'OrganizationId',type:'number'},
        {name:'RiskLevelId',type:'number'},
        {name:'TimeZoneCode',type:'string'}]);
        obj.contact = new FieldsFormController(VictimController.elementPrefixId,'ContactContainerId',[
            {name:'PrimaryPhone',type:'string'},
            {name:'Email',type:'string'},
            {name:'SecondaryPhone',type:'string'},
            {name:'SecondaryEmail',type:'string'}]);
        obj.samaPhoneNumber = new FieldsFormController(VictimController.elementPrefixId,'MobileAppContainerId',[{name:'SamaPhoneNumber',type:'string'}]);
        obj.samaCheckbox = new FieldsFormController(VictimController.elementPrefixId,'MobileAppCheckboxContainerId',[{name:'IsStalkerMobile',type:'number'}]);
        obj.sama = new FieldsFormController(VictimController.elementPrefixId,'MobileAppParametersContainerId',[
            {name:'ProximityCaution',type:'number'},
            {name:'ProximityWarning',type:'number'},
            {name:'ProximityDanger',type:'number'},
            {name:'SamaAssociateEnrolleeId',type:'number'}
        ]);
        obj.pair = new FieldsFormController(VictimController.elementPrefixId,'PairEnrolleeContainerId',[
            {name:'OffenderId',type:'number'}]);
        obj.getValues = function(lArr){
            var getArr = lArr?lArr:['samaPhoneNumber','detail','contact','samaCheckbox','sama'];
            var val ={};
            for(var i=0;i<getArr.length;i++){
                Object.assign(val,this[getArr[i]].getValues());
            }
            return val;
        };
        return obj;
    }
    var VictimForm = VictimController.Form(); 
    window.VictimController = VictimController;
    var _IsValidSAMA = function(aSAMAResponse){
        var isValid = true;
        if(!isNullOrUndefined(aSAMAResponse)){
            //validate SAMARegistration 
            if(!isNullOrUndefined(aSAMAResponse.StalkerMobile)){
                switch(aSAMAResponse.StalkerMobile.Id){
                    case -1:
                        console.log('StalkerMobileRegistration is wrong')
                        break;
                    case -2:
                        console.log('StalkerMobileRegistration already exists')
                        StalkerController.PreventPhoneNumberInUse();
                        $('#uVictimProfileSamaPhoneNumberEdit').removeClass('ValidateSuccess').addClass('ValidateError');
                        isValid = false;
                        break;
                }
                return isValid;
            }
            if(!isNullOrUndefined(aSAMAResponse.Association)){
                switch(aSAMAResponse.Association.Id){
                    case -1:
                        console.log('Association is wrong')
                        break;
                    case -2:
                         console.log('Association already exists')
                        break;
                }
            }
            if(!isNullOrUndefined(aSAMAResponse.Association)){
                switch(aSAMAResponse.Zone.Id){
                    case -1:
                        console.log('Zone is wrong')
                        break;
                    case -2:
                        console.log('Zone already exists')
                        break;
                }
            }
            return isValid;
        }
    }
    var OffenderPairComponent = {
        elementId:'uVictimProfileSamaAssociateEnrolleeId',
        selected:null,
        toggle:function(flg){
            $(this.elementId).toggle(flg);
            $(this.elementId+'Edit').toggle(flg);
        },
        getSelected:function(){
            document.getElementById(this.elementId+'Edit').value;
            return this.selected;
        },
        setSelected: function(aValue){
            this.selected = EnrolleeHelper.getBy('Id',aValue);
            document.getElementById(this.elementId).value = this.selected.FullName;
            document.getElementById(this.elementId+'Edit').value = aValue;
        },
        items:[],
        Render:function(lOrganizationId){
            var elm = document.getElementById(this.elementId+'Edit');
            elm.innerHTML ='<option value="-1">-</option>';
            var items = EnrolleeHelper.getByOrganizationId(lOrganizationId,{name:'IsAssigned',value:true},'FullName');
            var list = [];
            items.map(function(o){
                var option = document.createElement("option");
                option.text =  o.FullName+' (' +o.PrimaryId+')';
                option.value = o.Id;
                elm.appendChild(option);
                list.push({
                    text:o.FullName+' (' +o.PrimaryId+')',
                    value:o.Id
                });
            });
            this.items = list;
        },
    };
    var AgentListComponent = {
        elementId:'uVictimProfileSamaAssociateEnrolleeId',
        Render: function(lOrganizationId){
            var uSelectedId = AgentHelper.getId(lOrganizationId);
            var uAgents = AgentHelper.getBy('OrganizationId',lOrganizationId);
            populateEditView({ 'AgentId': uSelectedId }, [
                    { 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': uAgents, 'DataValueField': 'Id', 'DataTextField': 'FullName' }
            ], {}, 'uEnrolleeProfile', 'Edit');
        }
    };
    // EnrolleeId list view.
    var EnrolleeIdListViewComponent = {
        SelectByOffenderId:function(lOffenderId){
            if (lOffenderId === -1) {
                mEnrolleesControls.uVictimProfileOffenderIdListView.selectedIndex(0);
            } else {
                mEnrolleesControls.uVictimProfileOffenderIdListView.selected(lOffenderId);
            }
        },
         /**
         * user VictimProfile View Actions
         */
        Dispose:function(){
            if(mEnrolleesControls.uVictimProfileOffenderIdListView){
                mEnrolleesControls.uVictimProfileOffenderIdListView.dispose();
                mEnrolleesControls.uVictimProfileOffenderIdListView = null;
            }
        },
         /**
         * This function will load data source of Agents based on selected Organization
         * @param  {} aOrganizationId
         */
        Render:function(aOrganizationId){
            "use strict";
            if (isNullOrUndefined(mEnrolleesControls.uVictimProfileOffenderIdListView)) {
                var lColumns = [
                    { 'id': 'FullName', 'title': localizeWrapper('cEnrolleeName'), 'dataField': 'FullName', 'width': 'autoData', 'minWidth': 60, 'sortable': false, 'cssClass': null, 'formatMethod': null }
                ]; 
                mEnrolleesControls.uVictimProfileOffenderIdListView = new sumo.controls.ListView('uVictimProfileOffenderIdListView', 'uVictimProfileOffenderIdListViewHolder', { 'keyField': 'Id', 'selectMethod': 'single', 'cssClass': 'VeritracksListView', 'canUnselect': false }, lColumns);
            }
            var lOffendersList = EnrolleeHelper.getByOrganizationId(aOrganizationId); //getEnrolleesByOrganizationId(aOrganizationId)
            mEnrolleesControls.uVictimProfileOffenderIdListView.setDataSource(lOffendersList);
        }
    };
    /**
     * import {resetContentHolders} from 'Utils/UI';
     * import {populateEditView} from 'Default';
     */
    // UI
    function uEnrolleeProfileRisklLevelIdEdit_OnChange(self){
        var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);
        var lRiskLevelId = $(self).val();
        var lOrganizationId = $('#uEnrolleeProfileOrganizationIdEdit').val();
        DisplayVictimProfileRiskLevel(lOrganizationId,lRiskLevelId);
        if (mEnrolleesControls.VictimProfileValidator) {
            mEnrolleesControls.VictimProfileValidator.IsValid();
        }
        
    }
    /**
     * Checks for ORI Property  display_victim_risklevel
     * hides or shows uVictimProfileProfileRiskLevelContainerId element
     * returns if ORI supports display_victim_risklevel
     */
    function DisplayVictimProfileRiskLevel(lOrganizationId,lRiskLevelId){
        var lDisplayVictimRiskLevel = veritracks.core.GetOriProperty(lOrganizationId, 'display_victim_risklevel');
        if(lDisplayVictimRiskLevel){
            $('#uVictimProfileProfileRiskLevelContainerId').show();
            $('select#uEnrolleeProfileRiskLevelIdEdit').val(lRiskLevelId);
            $('#uEnrolleeProfileRiskLevelIdEdit').addClass('Validate');
        }else { 
            $('#uVictimProfileProfileRiskLevelContainerId').hide();
            $('#uEnrolleeProfileRiskLevelIdEdit').removeClass('Validate');

        }
        return lDisplayVictimRiskLevel;
    }

    VictimController.Render = function(){
        //here all the population when 
        var lVictim = GetEnrollee(mEnrolleesData.VictimProfileCurrent.Id);
        PopulateDetailView(mEnrolleesData.VictimProfileCurrent, {
            'VictimId': EnrolleeNameFormatter,
            'IsStalkerMobile':HasEnrolleeMobileAppFormatter,
        }, 'uVictimProfile');
        if(mEnrolleesData.VictimProfileCurrent.IsStalkerMobile){
            PopulateDetailView(mEnrolleesData.VictimProfileCurrent, {
                'IsStalkerMobile':HasEnrolleeMobileAppFormatter,
                'SamaAssociateEnrolleeId':EnrolleeIdLinkFormatter
            }, 'uVictimProfile');
            PopulateDetailView(mEnrolleesData.VictimProfileCurrent, {
                'ProximityCaution':ProximityZoneFormatter,
                'ProximityDanger':ProximityZoneFormatter,
                'ProximityWarning':ProximityZoneFormatter
            }, 'cVictimProfile');
        }
        
        PopulateDetailView(lVictim, {
            'AgentId': AgentNameFormatter,
            'TimeZoneCode': timezoneCodeFormatter,
            'OrganizationId': OrganizationNameFormatter,
            'Birthdate': BirthDateStringFormatter,
            'FullName':FullNameSpecialCharsFormatter,
            'RiskLevelId': VictimRiskLevelFormatter,
        }, 'uEnrolleeProfile');
        
        //StalkerController.Render(mEnrolleesData.VictimProfileCurrent.OrganizationId);
        $('#uVictimProfileOffenderId').html(EnrolleeIdLinkFormatter(mEnrolleesData.VictimProfileCurrent.OffenderId));
        var OrganizationState = new OrganizationController(mEnrolleesData.VictimProfileCurrent.OrganizationId),
        IsSAMAEnabled = OrganizationState.IsPropertySupported(StalkerController.sama_property); //&& mEnrolleesData.VictimProfileCurrent.IsStalkerMobile === 1;
        $('#uEnrolleesSecondaryMenuVictimAssignments').toggle(!IsSAMAEnabled);
        $('#uEnrolleesVictimNotifications').toggle(!IsSAMAEnabled);
        EnrolleeIdListViewComponent.Render(mEnrolleesData.VictimProfileCurrent.OrganizationId);
        if(lVictim){
            AgentListComponent.Render(lVictim.OrganizationId);
            StalkerController.Render(lVictim.OrganizationId);
            
            DisplayVictimProfileRiskLevel(lVictim.OrganizationId);
        }
    };
    
    VictimController.EditMode = function(aEnrollee){
        // var lOrganizationId = $('#uEnrolleeProfileOrganizationIdEdit').val();
        var lRiskLevelsByOrg = GetVictimRiskLevels(),
            lDefaultValue = -1;
        var aFieldsEnrolleeProfile = [
        { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource':OrganizationSortFormatter(), 'DataValueField': 'Id', 'DataTextField': 'Name' },
        { 'Id': 'TimeZoneCode', 'Type': 'Dropdown', 'DataSource':getDataItems('TimeZone'), 'LocaleName': 'TimeZone', 'DataValueField': 'TimeZoneCode', 'DataTextField': 'Name' },
        { 'Id': 'RiskLevelId', 'Type': 'Dropdown', 'DataSource': lRiskLevelsByOrg, 'DataValueField': 'Id', 'DataTextField': 'VictimRiskLevelName', 'DefaultValue': lDefaultValue.toString(),'insertBlank':true }
        ],
        aFieldsVictimProfile = [
            { 'Id': 'TimeZoneCode','Type': 'Dropdown','DataSource':getDataItems('TimeZone'),'LocaleName': 'TimeZone', 'DataValueField': 'TimeZoneCode', 'DataTextField': 'Name' },
        ];
        populateEditView(aEnrollee,aFieldsEnrolleeProfile , {}, 'uEnrolleeProfile', 'Edit');
        populateEditView(mEnrolleesData.VictimProfileCurrent,aFieldsVictimProfile, {}, 'uVictimProfile', 'Edit',localizeDataItem);
        //UI Fields
        var lOffender = getDataItem(mEnrolleesData.VictimProfileCurrent.OffenderId, 'Enrollees');
        $('#uEnrolleeProfileAgentIdEdit').val(mEnrolleesData.VictimProfileCurrent.AgentId);
        if(mEnrolleesData.VictimEditingId === -1){
            mEnrolleesData.VictimProfileCurrent.TimeZoneCode = EnrolleeHelper.getLocalTimeZoneGuess('TimeZoneCode');
        }

        $('#uEnrolleeProfileTimeZoneCodeEdit').val(mEnrolleesData.VictimProfileCurrent.TimeZoneCode);
        OffenderPairComponent.Render(mEnrolleesData.VictimProfileCurrent.OrganizationId);
        $('#uVictimProfileSamaAssociateEnrolleeIdEdit option[value='+mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId+']').attr('selected','selected');
        mEnrolleesControls.VictimProfileValidator = new Validator('uVictimProfilePanel',mRegexValidation);
        //UI controls
        $(aContentHolderId).hide('fast',resetContentHolders);
        $(editBtn).hide();
        $(AddBtn).hide();
        $(SaveBtn).show();
        $(CancelBtn).show();
        EnterEditMode(VictimController.aContainerId);
        VictimController.IsEditMode = true;
        //Reconsider Stalker Rendering after populating Edit Mode
        StalkerController.Render(mEnrolleesData.VictimProfileCurrent.Organization);//Add
        $('#uVictimProfileOffenderId').show();
    };
    VictimController.ExitEditMode = function(){
        if (mStateManager.IsSystemState('Primary',"Profile")) {
            if(mEnrolleesControls.VictimProfileValidator){
                mEnrolleesControls.VictimProfileValidator.dispose();
            }
            mEnrolleesControls.VictimProfileValidator = null;
            $(aContentHolderId).show('fast',resetContentHolders);
            // $('#uEnrolleeProfilePrimaryId').show();
            $(editBtn).show();
            $(AddBtn).show();
            $(SaveBtn).hide();
            $(CancelBtn).hide();
            // $('#uVictimProfileOffenderId').show();
           ExitEditMode(VictimController.aContainerId);
           VictimController.IsEditMode = false;
        }
    };

    /**
     * Updates the CardView selected Data Item to make a realtime change
     * @param  {} aVictimProfile
     */
    var _UpdateSelectedCardViewItem = function(aVictimProfile){
        if(aVictimProfile){
            var lVictim = mEnrolleesControls.CardView.selectedDataItem();
            lVictim.FirstName = aVictimProfile.FirstName;
            lVictim.LastName = aVictimProfile.LastName;
            lVictim.FullName = aVictimProfile.FullName;
            mEnrolleesControls.CardView.updateSingleItem(lVictim);
        } 
    };
    
    // UI Main Actions
    function uCancelVictimButton_OnClick(){
        VictimController.ExitEditMode();
        EnrolleeIdListViewComponent.Dispose();//-remove ListView
        mEnrolleesData.VictimProfileCurrent = Object.assign(new VictimProfile(),aTempVictim);
        VictimController.Render();//re-render

    }
    function uAddVictimButton_OnClick() {
        VictimController.hideLoading();
        var lEnrollee = new Enrollee();
        aTempVictim = mEnrolleesData.VictimProfileCurrent;
       
        mEnrolleesData.VictimProfileCurrent = new VictimProfile();
        mEnrolleesData.VictimEditingId = -1;
        VictimController.EditMode(lEnrollee);
        var lOrganizationId = parseInt(VictimForm.detail.getValue('OrganizationId'));
        OffenderPairComponent.Render(lOrganizationId);
        AgentListComponent.Render(lOrganizationId);
        StalkerController.Render(lOrganizationId);
        DisplayVictimProfileRiskLevel(lOrganizationId);
    }
    function uEditVictimButton_OnClick() {
        VictimController.hideLoading();
        aTempVictim = Object.assign({},mEnrolleesData.VictimProfileCurrent);
        var lEnrollee = GetEnrollee(mEnrolleesData.VictimCurrentId);
        //Vulnerability 3254.2
        lEnrollee.FirstName = veritracks.system.decodeHtml(lEnrollee.FirstName);
        lEnrollee.LastName = veritracks.system.decodeHtml(lEnrollee.LastName);

        mEnrolleesData.VictimEditingId = mEnrolleesData.VictimCurrentId;
        VictimController.EditMode(lEnrollee);
        //TODO: use ORI Flag
        DisplayVictimProfileRiskLevel(lEnrollee.OrganizationId,lEnrollee.RiskLevelId);
        
    }
    function uLegacySave(){
        VictimForm.sama.removeValidations();
        mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId = -1;
        if (mEnrolleesControls.VictimProfileValidator.IsValid()) {
            var lEnrollee = GetEnrollee(mEnrolleesData.VictimEditingId),
                lEnrolleeEdit;
            if (isNullOrUndefined(lEnrollee)) {
                mEnrolleesData.VictimProfileCurrent = new VictimProfile();
                mEnrolleesData.VictimProfileCurrent.IsNewVictim = 1;
                lEnrolleeEdit = new Enrollee();
            } else {
                lEnrolleeEdit = $.extend([], lEnrollee);
            }
            var lTransactionId = moment().format("YYYYMMDDHHmmss");
            populateFromEditView(mEnrolleesData.VictimProfileCurrent, 'uVictimProfile', 'Edit');
            lEnrolleeEdit.FirstName = $('#uEnrolleeProfileFirstNameEdit').val();
            lEnrolleeEdit.LastName = $('#uEnrolleeProfileLastNameEdit').val();
            lEnrolleeEdit.AgentId = parseInt($('#uEnrolleeProfileAgentIdEdit').val());
            lEnrolleeEdit.OrganizationId = parseInt($('#uEnrolleeProfileOrganizationIdEdit').val());
            lEnrolleeEdit.TransactionId = lTransactionId;
            mEnrolleesData.VictimProfileCurrent.FirstName = lEnrolleeEdit.FirstName;
            mEnrolleesData.VictimProfileCurrent.LastName = lEnrolleeEdit.LastName;
            mEnrolleesData.VictimProfileCurrent.AgentId = lEnrolleeEdit.AgentId;
            mEnrolleesData.VictimProfileCurrent.OrganizationId = lEnrolleeEdit.OrganizationId;
            mEnrolleesData.VictimProfileCurrent.TransactionId = lTransactionId;
            lEnrolleeEdit.TimeZoneCode = mEnrolleesData.VictimProfileCurrent.TimeZoneCode;
            var lBuilder = new SumoPredicateBuilder();
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional('TimeZoneCode', mEnrolleesData.VictimProfileCurrent.TimeZoneCode, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            var lTimezone = query(getDataItems('TimeZone'), lBuilder.RootExpression);
            for(var lKey in lTimezone) {
                if (lTimezone.hasOwnProperty(lKey)) {
                    lEnrolleeEdit.TimeZoneId = lTimezone[lKey].Id;
                    mEnrolleesData.VictimProfileCurrent.TimeZoneId = lTimezone[lKey].Id;
                }
            }
            function enrolleesVictimEnrolleeSave_OnComplete(aParams, aData) {
                "use strict";
                // update browser & server cache
                var lBuilder = new SumoPredicateBuilder();
                if (aParams.Id == -1) {
                    lBuilder.AddNewExpressionConditional('Id', aData.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                    ReadMultiple(gObjectList.VictimProfile.AssemblyQualifiedName, lBuilder.RootExpression, 0, victimProfileCreate_OnRead, failure, aParams, null, 0);
                } else {
                    victimProfileCreate_OnRead(aParams, [mEnrolleesData.VictimProfileCurrent]);
                }
                function victimProfileCreate_OnRead(aParams, aData) {
                    var lVictim = aParams;
                    var lVictimProfile = aData[0];
                    if (lVictimProfile) {
                        lVictim.Id = lVictimProfile.Id;
                        lVictim.EnrolleeType = 2;
                        lVictim.FirstName = mEnrolleesData.VictimProfileCurrent.FirstName.toUpperCase();
                        lVictim.LastName = mEnrolleesData.VictimProfileCurrent.LastName.toUpperCase();
                        lVictim.FullName = lVictim.LastName + ', ' + lVictim.FirstName;
                        lVictim.PrimaryId = lVictimProfile.PrimaryId;
                        // fix for new enrollee timezone
                        lBuilder.Clear();
                        lBuilder.AddNewExpressionConditional('TimeZoneCode', lVictim.TimeZoneCode, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                        var lTimezone = query(getDataItems('TimeZone'), lBuilder.RootExpression);
                        for (var lKey in lTimezone) {
                            if (lTimezone.hasOwnProperty(lKey)) {
                                lVictim.TimeZoneId = lTimezone[lKey].Id;
                            }
                        }
                        lVictim.Birthdate = '';
                        WriteSingle(lVictim, function enrolleeVictimWrite_OnSuccess(aParams, aData) {
                            setDataItem(aData.Id, 'Enrollees', aData);
                            AssignGlobalIds(gEnrolleeIds, getCacheItem('Enrollees'), 'Id'); // this new line fixes ticket 980
                            mStateManager.GoTo('Enrollees.Victims.Profile.Events.' + aData.Id.toString());
                            // VictimController.ExitEditMode();
                            console.log('Enrollees.Victims.Profile.Events.' + aData.Id.toString(),aParams,aData,uSAMAResponse)
                            enrolleesDataListConverter();
                            _UpdateSelectedCardViewItem();
                            VictimController.hideLoading();
                            StalkerController.Render(mEnrolleesData.VictimProfileCurrent.OrganizationId);
                        }, failure, null, true);
                    }
                }
            }
            function enrolleesVictimEnrolleeSave_OnFailure(aParams, a, b, c) {
                "use strict";
            }
            mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId = -1;
            if(VictimController.DisableSAMA){
                var lRegistration = new SAMAVictimStatus();
                lRegistration.Id = mEnrolleesData.VictimProfileCurrent.Id;
                lRegistration.CellPhoneNumber = mEnrolleesData.VictimProfileCurrent.SamaPhoneNumber;
                lRegistration.HasVictimMobileApp = 0;
                lRegistration.SAMAFlag = 1;
                WriteSingle(lRegistration, function(){
                    WriteSingle(mEnrolleesData.VictimProfileCurrent, enrolleesVictimEnrolleeSave_OnComplete, enrolleesVictimEnrolleeSave_OnFailure, lEnrolleeEdit, true);
                }, failure, null, true);
                //sama enabled to non-sama enabled
            }else{
                WriteSingle(mEnrolleesData.VictimProfileCurrent, enrolleesVictimEnrolleeSave_OnComplete, enrolleesVictimEnrolleeSave_OnFailure, lEnrolleeEdit, true);
            }
            EnrolleeIdListViewComponent.Dispose();//-remove ListView
            // enrolleeVictimExitEditMode();
            VictimController.ExitEditMode();
            mEnrolleesControls.VictimProfileValidator = null;
        }
    }
    function uSAMASave(){
        var e = mEnrolleesData.VictimProfileCurrent.OffenderId>0?VictimForm.getValues(['samaPhoneNumber','detail','contact','samaCheckbox']):VictimForm.getValues();
        if(e.IsStalkerMobile == 0){
            VictimForm.sama.removeValidations();
        }
        //Vulnerability 3254.2 
        e.FirstName = veritracks.system.encodeHtml(e.FirstName);
        e.LastName = veritracks.system.encodeHtml(e.LastName);
        e.FullName = veritracks.system.encodeHtml(e.FullName);
        if(e.FirstName.length > 25 || e.LastName.length > 25)
        {
                var errorLocation = e.FirstName.length > 25? 'First Name':'Last Name';
                mActivityNotification.addNotification('Save error: ' + errorLocation+' too long.');
                return;
        }
        var isValid = mEnrolleesControls.VictimProfileValidator.IsValid();
        if(!isValid){
            mActivityNotification.addNotification('Please review Fields');
            return;
        }
        VictimController.showLoading();
        var lEnrollee = GetEnrollee(mEnrolleesData.VictimEditingId),
        isEditMode = !isNullOrUndefined(lEnrollee);
        if(!isEditMode){
            mEnrolleesData.VictimProfileCurrent = new VictimProfile();
            mEnrolleesData.VictimProfileCurrent.IsNewVictim = 1;
        }
        e.IsNewVictim = convertBoolToInteger(!isEditMode);
        if (isEditMode){
            e.PrimaryId = lEnrollee.PrimaryId;
        }
        mEnrolleesData.VictimProfileCurrent.setValues(e);
        if(!isEditMode){
            mEnrolleesData.VictimProfileCurrent.VictimUserId = gUserDetails.UserId;
        }
        if(!!e.IsStalkerMobile){
            mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId = e.SamaAssociateEnrolleeId;
        }else if(mEnrolleesData.VictimProfileCurrent.OffenderId == -1) {
            mEnrolleesData.VictimProfileCurrent.ProximityCaution = -1;
            mEnrolleesData.VictimProfileCurrent.ProximityWarning = -1;
            mEnrolleesData.VictimProfileCurrent.ProximityDanger = -1;
            mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId = -1;
        }
        mEnrolleesData.VictimProfileCurrent.IsNewVictim = e.IsNewVictim;
        var OnSave = function(aParams,aData,uSAMAResponse){
            if(!_IsValidSAMA(uSAMAResponse)){
                //mStateManager.GoTo('Enrollees.Victims.Profile.Events.' + aData.Id.toString());
                VictimController.hideLoading();
                //return;
            }else {
                mStateManager.GoTo('Enrollees.Victims.Profile.Events.' + aData.Id.toString());
                VictimController.ExitEditMode();
                console.log('Enrollees.Victims.Profile.Events.' + aData.Id.toString(),aParams,aData,uSAMAResponse)
                enrolleesDataListConverter();
                _UpdateSelectedCardViewItem();
                VictimController.hideLoading();
                EnrolleeIdListViewComponent.Dispose();//-remove ListView
                StalkerController.Render(mEnrolleesData.VictimProfileCurrent.OrganizationId);
            }
            VictimController.Render();//re-render
        };
        var OnSaveFail = function(){
            //Error
            VictimController.hideLoading();
        }
        if(mEnrolleesData.VictimProfileCurrent.IsNewVictim == 1){
            mEnrolleesData.VictimProfileCurrent.Write(OnSave,OnSaveFail);
        }else {
            mEnrolleesData.VictimProfileCurrent.Update(OnSave,OnSaveFail);
        }
    }
    
    function uSaveVictimButton_OnClick() {
        uSAMASave();//new SAMA
    }
    // VictimProfile ->select ori   
    function uVictimProfileOrganizationIdEdit_OnChange() {
        var state = {
            Old: new OrganizationController(mEnrolleesData.VictimProfileCurrent.OrganizationId),
            New: new OrganizationController(parseInt(VictimForm.detail.getValue('OrganizationId'))),
            IsStalkerMobileEnabled: VictimForm.samaCheckbox.getValue('IsStalkerMobile'),
        },IsEditMode = !(mEnrolleesData.VictimProfileCurrent.Id === -1);
        var _Init = function(lOri){
            //If everything goes right..
            EnrolleeIdListViewComponent.Render(lOri);
            EnrolleeIdListViewComponent.SelectByOffenderId(lOri);
            OffenderPairComponent.Render(lOri);
            AgentListComponent.Render(lOri);
            StalkerController.Render(lOri);
            var isSupportedByORI = DisplayVictimProfileRiskLevel(lOri);
            if(!isSupportedByORI){
                // Reset RiskLevelId if is not supported 
                $('#uEnrolleeProfileRiskLevelIdEdit').val(1);
                mEnrolleesData.VictimProfileCurrent.RiskLevelId =1;
            }
            if (mEnrolleesControls.VictimProfileValidator) {
                mEnrolleesControls.VictimProfileValidator.IsValid();
            }
            
        }
        if(IsEditMode){
            //Edit mode enabled.. so be careful 
            //check the same if Current victim is enrolled and we are switching 
            // to amn ORI that does not support .  
            // Validate if: Victim is already enrolled to SAMA and is switching to a new ORI 
            // Validate if: Stalker is enable for this Victim, 
            
            
            if(mEnrolleesData.VictimProfileCurrent.IsStalkerMobile){
                var sameORI = state.New.Id === state.Old.Id; 
                if(state.Old.IsPropertySupported(sama_property) && !state.New.IsPropertySupported(sama_property)){
                    StalkerController.modal('Warning',localizeWrapper('cStalkerDisableEnrollee'),'Continue','Cancel',null,function(){
                        $("#uVictimProfileSamaPhoneNumberEdit").addClass("ValidateRequired");
                        VictimForm.detail.setValue('OrganizationId',state.New.Id);
                        VictimController.DisableSAMA = true;
                        _Init(state.New.Id);
                        ClosePopup();
                    },function(){
                        $("#uVictimProfileSamaPhoneNumberEdit").addClass("ValidateRequired");
                        VictimForm.detail.setValue('OrganizationId',state.Old.Id);
                        $('#uVictimProfileSamaAssociateEnrolleeIdEdit option[value='+mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId+']').attr('selected','selected');
                        _Init(state.Old.Id);
                        VictimController.DisableSAMA = false;
                        ClosePopup();
                    })
                    return;
                } else {
                    var isPaired = mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId >0;
                    if(isPaired){
                        VictimController.PairChanged = !sameORI
                        var e = {
                            Old:mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId,
                            New:parseInt(VictimForm.sama.getValue('SamaAssociateEnrolleeId')),
                        };
                        //e.Old != e.New && 
                        if(!sameORI){
                            StalkerController.PreventORIChangePairing(function(){
                                VictimForm.detail.setValue('OrganizationId',state.New.Id);
                                _Init(state.New.Id);
                            },function(){
                                VictimForm.detail.setValue('OrganizationId',state.Old.Id);
                                _Init(state.Old.Id);
                                $('#uVictimProfileSamaAssociateEnrolleeIdEdit option[value='+mEnrolleesData.VictimProfileCurrent.SamaAssociateEnrolleeId+']').attr('selected','selected');
                            });
                        }
                        
                    }
                  
                    _Init(state.New.Id);
                    //VictimForm.sama.displayOnly('SamaAssociateEnrolleeId',false);
                }
            }
        }else {
            // new one 
            
        }
       
        _Init(state.New.Id);
       
    }
    window.EnrolleeIdListViewComponent = EnrolleeIdListViewComponent;
    window.uVictimProfileOrganizationIdEdit_OnChange = uVictimProfileOrganizationIdEdit_OnChange;
    window.uAddVictimButton_OnClick = uAddVictimButton_OnClick;
    window.uEditVictimButton_OnClick = uEditVictimButton_OnClick;
    window.uSaveVictimButton_OnClick = uSaveVictimButton_OnClick;
    window.uCancelVictimButton_OnClick = uCancelVictimButton_OnClick;
    window.uEnrolleeProfileRisklLevelIdEdit_OnChange = uEnrolleeProfileRisklLevelIdEdit_OnChange;
})();
